module.exports = __webpack_public_path__ + "static/img/nbg_region.98176242.png";